<template>

  <div class="this">

    <label class="visit">{{$t('Visit')}} <a href="https://winerz.com" target="_blank">winerz.com</a></label>

    <div v-if="alreadyHasAccount">
      <h1>{{$t('Account already exists')}}</h1>
      <p>
        Hi, you already have an account and you are logged in.
        <br><br>
        <a :href="appUrl">{{$t('Go to app')}}</a>
      </p>
    </div>

    <div v-bind:class="['main-form', { disabled : pleaseWait }]" v-if="!alreadyHasAccount">

      <h1>{{$t('REGISTER')}}</h1>

      <form @submit.prevent="register">

          <p>
              <label for="signin_email">
                  <span>{{$t('Enter your E-mail')}} *</span>
                  <input type="email" name="email" id="signin_email" required  v-model="email" />
                  <span class="error" for="email"></span>
              </label>
          </p>

          <p>
              <label class="psswd_display" for="signin_pwd">
                  <span>{{$t('Choose a Password')}} *</span>
                  <div style="position : relative">
                    <input v-bind:type="passwordShow ? 'text' : 'password'" name="pwd" id="signin_pwd" required  v-model="password" minlength="6" />
                    <span class="psswd_reqs">{{$t('minimum : 6 characters + 1 number + 1 special character')}}</span>
                  </div>
                  <span class="error" for="pwd"></span>
                  <span class="psswd_display_trigger" @click="passwordShow = !passwordShow"></span>
              </label>
          </p>   
          
          <p>
              <label for="signin_age" class="checkbox"><input type="checkbox" name="age" id="signin_age" required>{{$t('I certify that Im 18 year of age or older.')}}</label>
              <!-- <label for="signin_tos" class="checkbox"><input type="checkbox" name="tos" id="signin_tos" required> I've read and agree <a href="privacy.html" target="_blank">terms of service</a> & <a href="#" target="_blank">privacy policy</a>.</label> -->
              <label for="signin_news" class="checkbox"><input type="checkbox" v-model="optin" name="news" id="signin_news">{{$t('I accept to receive news and special offers')}}</label>
              <span class="error" for="age tos news"></span>
          </p>
          <div id="signin_submit">
              <p class="error text-center" v-if="signupError">
                <span v-if="signupErrorMessage !== ''" v-html="signupErrorMessage"></span>
                <router-link to="/login" v-if="signupErrorEmailTaken" style="text-underline-offset: 0.2rem;">{{$t('Did you wanted to log in?')}}</router-link>
              </p>
              <br />
              <input type="submit" :value="$t('CREATE MY ACCOUNT')" class="btn_blue" />
              <span>{{$t('For free')}} :)</span>
              <p style="text-align: center; font-size: 1.2rem">
                {{$t('Already have an account?')}}
                <br />
                <router-link to="/login" style="text-underline-offset: 0.2rem;">{{$t('Log in here')}}</router-link>
              </p>
          </div>
      </form>

    </div>

    <div class="waiter" v-show="pleaseWait">
      <h1 v-html="$t('pleasewait-create')"></h1>
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>

  </div>


</template>


<style scoped>

.this {
  position : relative;
}
.visit {
  color : white;
  text-align : center;
  position: absolute;
  bottom : -7rem;
  left : 0;
  display : block;
  width : 100%;
}
.visit a { color : white !important; text-underline-offset: .1rem; }
</style>



<script>

import { authService } from '../services/auth';
import axios from 'axios';
import { Hub, Logger } from 'aws-amplify';


export default {
  name: 'Register',

  metaInfo () { 
    return { title: this.$t("meta-title") } 
  },

  data: function() {
    return {
      email : "",
      // console : "xbox one",
      password : "",
      passwordShow : false,

      gamertag : "",
      console : "",
      sponsorship : "",
      optin : false,

      signupError : true,
      signupErrorMessage : "",
      signupErrorEmailTaken : false,

      pleaseWait : false,
      alreadyHasAccount : false,

      appUrl : ''
    }
  },
  async mounted(){

    window.analytics.page('register-page');
    window.analytics.track('visit-register-page');

    if (this.$route.query.m) this.email = decodeURIComponent(this.$route.query.m)

    this.appUrl = process.env.VUE_APP_APP_URL

    const user = await authService.getCurrentUser()
    // console.log(user)
    if (user !== null) {
      authService.redirectToApp()
    }

    this.$Amplify.Hub.listen("auth", ({ payload: { event, data } }) => {
      
      // console.log(event, data);

      switch (event) {
        case "customOAuthState":
            console.log("hub custom");
            break;
        case 'signIn':
            console.log('user signed in');
            break;
        case 'signUp':
            console.log('user signed up');
            break;
        case 'signOut':
            console.log('user signed out');
            break;
        case 'signIn_failure':
            console.log('user sign in failed');
            break;
        case 'tokenRefresh':
            console.log('token refresh succeeded');
            break;
        case 'tokenRefresh_failure':
            console.log('token refresh failed');
            break;
        case 'configured':
            console.log('the Auth module is configured');
      }
    });

  },
  methods : {

    ...authService,


    resetErrors() {
      this.signupError = false;
      this.signupErrorMessage = "";
      this.signupErrorEmailTaken = false;
    },

    async register() {

      this.resetErrors();
      this.pleaseWait = true;

      try {

        // // check disposable email
        // const disposableCheck = await axios.get(`https://disposable.debounce.io/?email=${this.email}`)
        // if (disposableCheck != null && disposableCheck?.data.disposable === "true") {
        //   throw { presignupError: this.$t("E-mail is not valid") }
        // }

        // Presignup validation
        let preSignUpOk = false;
        try {

          preSignUpOk = await authService.preSignUser("Cognito",
                                                      this.email,
                                                      this.sponsorship,
                                                      this.console,
                                                      this.gamertag,
                                                      this.optin);

        } catch (error) {
          // console.log(error.response.data.Errors[Object.keys(error.response.data.Errors)])
          throw { presignupError: error.response.data.Errors[Object.keys(error.response.data.Errors)] } 
        }

        const usrRegistration = await authService.awsRegisterBasic(this.email, this.password, this.email);

        if (authService.awsRegisteredUserData != null && authService.awsRegisteredUserData.user.username === this.email) {

          const signIn = await authService.awsSignin(this.email, this.password);
        
          const mapping = await authService.mapUser(this.email,
                                                 "Cognito",
                                                 this.sponsorship,
                                                 this.optin,
                                                 "",
                                                 "",
                                                 "");

          const user = mapping.data;
          
          try
          {
            window.analytics.identify(user.id, {
              email : user.email,
              created_At : user.created_At,
              updated_At : user.updated_At,
              status : user.status,
              emailConfirmed : false,
              type: 'registered-user',
              preferredLanguage : window.locale === 'fr-FR' ? window.locale : 'en-GB',
            })

            window.analytics.track('user-registered');
          }
          catch(error) {
            console.log("GA Tracking err", error)
          }
          
          try
          {
            // snap
            window.snaptr(`init`, `812fad02-2924-40d2-9be2-3999d35ad85d`, {
              "user_email": user.email
            });
            
            window.snaptr('track','SIGN_UP', {success:1});
          }
          catch(error) {
            console.log("SN Tracking err", error)
          }
          
          try
          {
            // fb
            window.fbq('track', 'CompleteRegistration');
          }
          catch(error) {
            console.log("FB Tracking err", error)
          }

          authService.redirectToApp();
        }

      }
      catch (error)
      {
        window.analytics.track('user-registration-error', error);

        this.signupError = true;
        
        // console.log(error)
        // debugger

        if (error.presignupError) {
          this.signupErrorMessage = error.presignupError;
        }
        else {

          switch (error.code) {
            case "InvalidPasswordException":
              this.signupErrorMessage = this.$t(`err-invalid-password`);
              break;

            case "UsernameExistsException":
              this.signupErrorMessage = this.$t(`err-email-taken`);
              this.signupErrorEmailTaken = true;
              break;
          
            default:
              this.signupErrorMessage = this.$t('err-default');
              break;
          }

        }

      }
      finally {
        this.pleaseWait = false;
      }
    }

    

  }
}
</script>



<i18n>
{
  "en": {
    "meta-title": "Winerz  |  Create account",
    "Visit": "Visit",
    "Account already exists": "Account already exists",
    "Go to app": "Go to app",
    "REGISTER": "REGISTER",
    "Enter your E-mail": "Enter your E-mail",
    "Choose a Password": "Choose a Password",
    "minimum : 6 characters + 1 number + 1 special character": "minimum : 6 characters + 1 number + 1 special character",
    "I certify that Im 18 year of age or older.": "I certify that I'm 18 year of age or older.",
    "I accept to receive news and special offers": "I accept to receive news and special offers",
    "Did you wanted to log in?": "Did you wanted to log in?",
    "For free": "For free",
    "Already have an account?": "Already have an account?",
    "Log in here": "Log in here",
    "pleasewait-create": "Please wait,<br />we finalize your account",
    "E-mail is not valid" : "E-mail is not valid",
    "err-invalid-password": "Please choose a password that applies the <strong>following rules</strong>:<br />- at least 6 characters<br />- 1 or more digits<br />- 1 or more special character",
    "err-email-taken": "There is already an account with this e-mail address.",
    "err-default": "An error occured when creating your account. Please check your input or try again later.",
    "CREATE MY ACCOUNT": "CREATE MY ACCOUNT"
  },
  "fr": {
    "meta-title": "Winerz  |  Inscription",
    "Visit": "Visite",
    "Account already exists": "Compte existant",
    "Go to app": "Aller à l'app",
    "REGISTER": "CRÉER UN COMPTE",
    "Enter your E-mail": "Entre ton E-mail",
    "Choose a Password": "Choisis un mot de passe",
    "minimum : 6 characters + 1 number + 1 special character": "minimum : 6 caractères + 1 chiffre + 1 caractère spécial",
    "I certify that Im 18 year of age or older.": "Je certifie que j'ai plus de 18 ans.",
    "I accept to receive news and special offers": "J'accepte de recevoir des news ou des offres de Winerz",
    "Did you wanted to log in?": "Tu souhaites t'identifier ?",
    "For free": "C'est gratuit",
    "Already have an account?": "Tu as déjà un compte ?",
    "Log in here": "Identifie-toi ici",
    "pleasewait-create": "Merci de patienter,<br />nous créons ton compte",
    "E-mail is not valid" : "E-mail non valide",
    "err-invalid-password": "Merci de choisir un mot de passe qui respecte les <strong>règles de sécurité suivantes</strong>:<br />- au moins 6 caractères<br />- 1 ou plusieurs chiffres<br />- 1 ou plusieurs caractères spéciaux",
    "err-email-taken": "Un compte existe déjà avec cette adresse e-mail",
    "err-default": "Une erreur est survenue lors de la création de ton compte, merci de véfifier ta saisie ou recommence ultérieurement",
    "CREATE MY ACCOUNT": "CRÉER MON COMPTE"
  }
}
</i18n>